<template>
  <div class="nav-bar" :class="[`${theme}-nav-bar`]"
       :style="bgColor ? { background: bgColor } : {}">
    <div class="left" @click="router.push('/home')">
      <img src="@/assets/images/logo.png" alt="">
      <span>中国设计风格的经典文化元素及原型数据库</span>
    </div>

    <ul class="center">
      <li v-for="item in tabList" :key="item.index" :class="[`tab-${item.index}`, {active: activeIndex === item.index}]"
          @click="jumpPage(item)">
        <span>{{ item.name }}</span>
      </li>
    </ul>

    <div class="right">
      <div class="search-container">
        <div class="custom-button search-button" @click="router.push('/searchResult')">
          <img :src="require(`@/assets/images/${theme === 'black' ? 'white' : 'black'}-search.png`)" alt="">
        </div>
        <div class="search-box">
          <input type="text" v-model="searchTerm" placeholder="输入检索" @keyup.enter="toSearchResult"/>
          <span class="divider"></span>
          <img src="@/assets/images/search.png" alt="" @click="toSearchResult"/>
        </div>
      </div>
      <div class="custom-button login-button">
        <img :src="require(`@/assets/images/${theme === 'black' ? 'white' : 'black'}-login.png`)" alt="">
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { addEvent } from '@/utils'

const router = useRouter()
const route = useRoute()

// tab导航
const activeIndex = ref(-1)
const tabList = [
  {
    name: '首页',
    index: 0,
    routeName: 'Home'
  },
  {
    name: '专题',
    index: 1,
    routeName: 'Browse'
  },
  {
    name: '检索',
    index: 2,
    routeName: 'SearchResult',
    query: {
      searchTerm: '',
      parameterValues: ''
    }
  },
  {
    name: '影像',
    index: 3,
    routeName: 'Image'
  }
]

function jumpPage (item) {
  activeIndex.value = item.index
  if (item.query) {
    router.push({
      name: item.routeName,
      query: item.query
    })
  } else {
    router.push({
      name: item.routeName,
      query: {}
    })
  }
}

// 导航栏的主题
const theme = ref('black')
const bgColor = ref('')

function getTheme () {
  if (route.name === 'Home' || route.name === 'Image') {
    theme.value = 'black'
  } else {
    theme.value = 'white'
  }
}

function scrollHandler () {
  // const clientHeight = document.documentElement.clientHeight
  const osTop = document.documentElement.scrollTop || document.body.scrollTop
  if (osTop >= 600) {
    bgColor.value = 'black'
  } else {
    bgColor.value = 'transparent'
  }
}

watch(route, () => {
  const current = tabList.find(item => item.routeName === route.name && item.query?.sectionId === route.query?.sectionId)
  if (current) {
    activeIndex.value = current.index
  } else {
    activeIndex.value = -1
  }

  getTheme()
  if (route.name === 'Home' || route.name === 'Image') {
    addEvent(window, 'scroll', scrollHandler)
  } else {
    window.removeEventListener('scroll', scrollHandler)
    bgColor.value = ''
  }
}, { immediate: true })

// 搜索
const searchTerm = ref('')

function toSearchResult () {
  router.push('/searchResult?searchTerm=' + searchTerm.value)
}
</script>

<style lang="scss" scoped>
.nav-bar {
  position: fixed;
  top: 0;
  z-index: 99;
  width: 100%;
  height: 90px;
  padding: 0 124px;

  &.black-nav-bar {
    background-color: transparent;
    color: white;
  }

  &.white-nav-bar {
    background-color: white;
    color: black;
  }

  //box-shadow: 2px 3px 6px rgba(0,0,0,0.1);
}

.left, .center, .right, .nav-bar {
  display: flex;
  align-items: center;
}

.left {
  margin-right: 174px;
  cursor: pointer;

  img {
    width: 31px;
    height: 30px;
    margin-right: 19px;
  }

  span {
    font-size: 20px;
    font-family: 'NotoSerifSC', system-ui;
  }
}

.center {
  flex: 1;

  li {
    font-size: 20px;
    margin-right: 69px;
    cursor: pointer;
    position: relative;

    span {
      display: flex;
      align-items: center;
      font-family: 'NotoSerifSC', system-ui;
    }
  }

  li.active {
    color: #C01A1A;

    &:after {
      display: -webkit-box;
      content: '';
      height: 2px;
      width: 28px;
      background-color: white;
      border-radius: 1px;
      position: absolute;
      bottom: -9px;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  //.tab-2 span:before, .tab-3 span:before {
  //  display: -webkit-box;
  //  content: '';
  //  width: 7px;
  //  height: 4px;
  //  background-size: 100% 100%;
  //  margin-right: 8px;
  //}
}

.black-nav-bar .center {
  //.tab-2 span:before, .tab-3 span:before {
  //  background-image: url("~@/assets/images/white-down-vector.png");
  //}
  li.active:after {
    background-color: #C01A1A;
  }
}

.white-nav-bar .center {
  //.tab-2 span:before, .tab-3 span:before {
  //  background-image: url("~@/assets/images/black-down-vector.png");
  //}
  li.active:after {
    background-color: #C01A1A;
  }
}

.right {
  .custom-button img {
    width: 19px;
    height: 19px;
  }

  .login-button img {
    width: 26px;
    height: 26px;
  }

  .search-box {
    display: none;
    height: 38px;
    width: 350px;
    padding: 0 20px;
    border-radius: 5px;
    overflow: hidden;
    background: white;
    align-items: center;

    input {
      flex: 1;
      height: 100%;
      font-size: 16px;
      color: black;
    }

    .divider {
      height: 25px;
      width: 2px;
      background: #c7c7c7;
      margin: 0 14px;
    }

    img {
      width: 20px;
      height: 20px;
    }
  }

  .search-container {
    margin-right: 45px;
    cursor: pointer;

    &:hover .search-box {
      display: flex;
    }

    &:hover .search-button {
      display: none;
    }
  }
}
</style>
